export const handleChangeDataModalEditFromStock = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_EDIT_FROM_STOCK', name, value
});